import { IconButton, AppBar, Toolbar, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button, Tabs, Tab, Tooltip, Switch, FormControl, InputLabel, Select, Chip, MenuItem } from "@material-ui/core";
import * as React from "react";
import { Theme } from "@material-ui/core/styles";
import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import { history } from "src/history.js";
import { AdminToolBar } from '../../components';
import { settingsStore } from '.';
import { default as ReactTable, ReactTableDefaults } from "react-table";
import "react-table/react-table.css";
import { companiesAdminStore } from '../CompaniesAdmin';

interface IAppSetting {
    app_setting_id: number;
    SettingName: string;
    SettingCategory: string;
    SettingType: string;
    SettingDisplayName: string;
    SettingLastUpdate: string;
    SettingDescription: string;
    SettingValue: string;
    dev_only: number;
}

const styles = ({ typography }: Theme) => createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    tableIconCell: {
        display: "flex",
        justifyContent: "center",
    },
    // tableIconHeader: {
    //   marginRight: "1rem",
    // },
    tableDefaultCell: {
        // marginRight: ".25rem",
        // marginLeft: ".25rem",
        display: "flex",
        alignItems: "center",
        fontFamily: typography.fontFamily,
    },
    tableDefaultHeader: {
        fontFamily: typography.fontFamily,
    },
});

@observer
class CompanySettings extends React.Component<any> {

    public state = { current_auth_id: 0, companySelectOpen: false }

    protected columns = [
        {
            Header: "Name",
            accessor: "FullName",
            width: 200
        },
        {
            Header: "Pharmacies",
            id: "Pharmacies",
            accessor: (a: any) => this.getPharmacyColumn(a)
        },
        {
            Header: "Company",
            id: "Company",
            accessor: (a: any) => this.getCompanyColumn(a)
        },
        {
            Header: "",
            id: "Save",
            accessor: (a: any) => this.getSaveColumn(a),
            width: 150
        },
    ]

    public filterCaseInsensitive = (filter: any, row: any) => {
        const id = filter.pivotId || filter.id;
        const content = row[id];
        if (typeof content !== 'undefined') {
            // filter by text in the table or if it's a object, filter by key
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {
                return String(content).toLowerCase().includes(filter.value.toLowerCase());
            }
        }
        return true;
    };

    public getPharmacyColumn = (row: any) => {
        if (row.sites.length === 0) {
            return null
        }
        else if (row.sites.length === 1) {
            return row.sites[0].displayName
        }
        else {
            const siteArr = row.sites
                .slice() // C-177
                .sort((a: any, b: any) => (a.displayName || '').localeCompare(b.displayName || ''))
                .map((s: any) => ` ${s.displayName}`);
            const siteString = siteArr.join();
            return siteString.substring(0, siteString.length - 1)
        }
    }

    public getCompanyChipInfo = (company_id: number) => {
        const company = companiesAdminStore.all_companies.find((c: any) => c.company_id === company_id);
        if (!company) {
            return 'none'
        }
        return (
            <React.Fragment>
                <b>{company.CompanyName}</b>
            </React.Fragment>
        )
    }

    public getSortedCompanyIds = (companyIds: number[]) => {
        return companyIds
            .slice() // C-177.1
            .sort((a: number, b: number) => {
                const companyA = companiesAdminStore.all_companies.find((c: any) => c.company_id === a);
                const companyB = companiesAdminStore.all_companies.find((c: any) => c.company_id === b);
                const nameA = companyA ? (companyA.CompanyName || '') : '';
                const nameB = companyB ? (companyB.CompanyName || '') : '';
                if (!companyA && !companyB) return a - b;
                if (!companyA) return 1;
                if (!companyB) return -1;
                return nameA.localeCompare(nameB);
            });
    }

    public dropCompany = (row: any, company_id: any) => {
        settingsStore.noCompanyUserList = settingsStore.noCompanyUserList.map((user: any) => {
            if (user.auth_id === row.auth_id) {
                return {
                    ...user,
                    company_ids: user.company_ids.filter((id: number) => id !== company_id)
                }
            }
            return user
        })
    }

    public handleSelect = (e: any, row: any) => {
        settingsStore.noCompanyUserList = settingsStore.noCompanyUserList.map((user: any) => {
            if (user.auth_id === row.auth_id) {
                return {
                    ...user,
                    company_ids: e.target.value
                }
            }
            return user
        })
    }

    public handleSave = (row: any) => {
        settingsStore.saveNoCompanyUser(row)
    }

    public getCompanyColumn = (row: any) => {
        const { classes } = this.props;
        return (
            <FormControl style={{ width: '80%' }}>
                <InputLabel htmlFor={"user_company"} shrink={true}>
                    Company
                  </InputLabel>
                <Select
                    // open={this.state.companySelectOpen && this.state.current_auth_id === row.auth_id}
                    // open={this.state.companySelectOpen}
                    // tslint:disable-next-line: jsx-no-lambda
                    // onOpen={() => this.setState({ companySelectOpen: true, current_auth_id: row.auth_id})}
                    // tslint:disable-next-line: jsx-no-lambda
                    // onClose={() => this.setState({ companySelectOpen: false, current_auth_id: 0 })}
                    multiple={true}
                    inputProps={{
                        name: "user_company",
                        id: "user_company",
                    }}
                    value={row.company_ids}
                    classes={{ root: classes.companySelect }}
                    // onChange={this.handleInput("materialSelectCompanyIDs")}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={(e) => this.handleSelect(e, row)}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderValue={(selected: any) => {
                        const sortedIds = this.getSortedCompanyIds(selected); // C-177.1
                        return (
                            <div style={{ whiteSpace: 'normal' }}>
                                 {sortedIds.map((c: any) => (
                                    <Chip style={{ marginTop: '3px' }} key={c} label={this.getCompanyChipInfo(c)} className={classes.chip} onDelete={() => { if (document.activeElement) { (document.activeElement as HTMLElement).blur() }; this.dropCompany(row, c) }} />
                                ))}
                            </div>
                        )
                    }}
                >
                     {companiesAdminStore.all_companies
                        .slice() // C-177.12
                        .sort((a: any, b: any) => (a.CompanyName || '').localeCompare(b.CompanyName || ''))
                        .map((company: any, index) => {
                            return (
                                <MenuItem key={index} value={company.company_id}>
                                    {company.CompanyName}
                                </MenuItem>
                            );
                        }
                    )}
                </Select>
            </FormControl>
        )
    }

    public getSaveColumn = (row: any) => {
        return (
            <Button
                variant={'contained'}
                color={'primary'}
                // tslint:disable-next-line: jsx-no-lambda
                onClick={() => this.handleSave(row)}
            >
                Save
            </Button>
        )
    }

    public render() {
        const { classes } = this.props;

        if (!settingsStore.no_company_user_list_loaded || !companiesAdminStore.all_companies) {
            return <div>Loading</div>
        };

        return (
            <div className={classes.root}>
                <ReactTable
                    column={{
                        ...ReactTableDefaults.column,
                        resizable: true,
                        // filterable: true,
                        className: this.props.classes.tableDefaultCell,
                        headerClassName: this.props.classes.tableDefaultHeader,
                    }}
                    data={settingsStore.noCompanyUserList}
                    columns={this.columns}
                    className="-striped -highlight"
                    filterable={true}
                    defaultFilterMethod={this.filterCaseInsensitive}
                />
            </div>
        );
    }

}

export default withStyles(styles, { withTheme: true })(CompanySettings);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Settings/NoCompanyUsersList.tsx